export default class FreezeScreen {
  public static createEmpty(): FreezeScreen {
    return new FreezeScreen();
  }
  constructor(
    public IsScreenFreezed: boolean = false,
    public UserName: string = '',
  ) {}
}
